<script>
import { ref } from "vue";
const value2 = ref([20, 50]);
export default {
  data() {
    return {
      ConstrSel: ["Select Sub Category", "Car Wash", "Construction"],
      value3: [20, 80],
      merge: 10,
      format: {
        prefix: "$",
        suffix: "0",
      },
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/service/search");
    },
  },
};
</script>
<template>
  <div class="col-xl-3 col-lg-4 theiaStickySidebar">
    <div class="stickysidebar">
      <div class="card mb-4 mb-lg-0">
        <div class="card-body">
          <form @submit.prevent="submitForm">
            <div
              class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom"
            >
              <h5><i class="ti ti-filter-check me-2"></i>Filters</h5>
              <a href="javascript:void(0);">Reset Filter</a>
            </div>
            <div class="mb-3 pb-3 border-bottom">
              <label class="form-label">Search By Keyword</label>
              <input
                type="text"
                class="form-control"
                placeholder="What are you looking for?"
              />
            </div>
            <div class="accordion border-bottom mb-3">
              <div class="accordion-item mb-3">
                <div class="accordion-header" id="accordion-headingThree">
                  <div
                    class="accordion-button p-0 mb-3"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-collapseThree"
                    aria-expanded="true"
                    aria-controls="accordion-collapseThree"
                    role="button"
                  >
                    Categories
                  </div>
                </div>
                <div
                  id="accordion-collapseThree"
                  class="accordion-collapse collapse show"
                  aria-labelledby="accordion-headingThree"
                >
                  <div class="content-list mb-3" id="fill-more">
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" checked />
                        All Categories
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Construction
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Car Wash
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Electrical
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Cleaning
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Plumbing
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" />
                        Designing
                      </label>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    id="more"
                    class="more-view text-primary fs-14"
                    >View more <i class="ti ti-chevron-down ms-1"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="accordion border-bottom mb-3">
              <div class="accordion-header" id="accordion-headingFour">
                <div
                  class="accordion-button p-0 mb-3"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordion-collapseFour"
                  aria-expanded="true"
                  aria-controls="accordion-collapseFour"
                  role="button"
                >
                  Sub Category
                </div>
              </div>
              <div
                id="accordion-collapseFour"
                class="accordion-collapse collapse show"
                aria-labelledby="accordion-headingFour"
              >
                <div class="mb-3">
                  <vue-select
                    :options="ConstrSel"
                    id="constrsel"
                    placeholder="Select Sub Category"
                  />
                </div>
              </div>
            </div>
            <div class="accordion border-bottom mb-3">
              <div class="accordion-header" id="accordion-headingFive">
                <div
                  class="accordion-button p-0 mb-3"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordion-collapseFive"
                  aria-expanded="true"
                  aria-controls="accordion-collapseFive"
                  role="button"
                >
                  Location
                </div>
              </div>
              <div
                id="accordion-collapseFive"
                class="accordion-collapse collapse show"
                aria-labelledby="accordion-headingFive"
              >
                <div class="mb-3">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Select Location"
                    />
                    <span class="icon-addon"><i class="ti ti-map-pin"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion border-bottom mb-3">
              <div class="accordion-header" id="accordion-headingSix">
                <div
                  class="accordion-button p-0 mb-3"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordion-collapseSix"
                  aria-expanded="true"
                  aria-controls="accordion-collapseSix"
                  role="button"
                >
                  Price Range
                </div>
              </div>
              <div
                id="accordion-collapseSix"
                class="accordion-collapse collapse show"
                aria-labelledby="accordion-headingSix"
              >
                <div class="filter-range">
                  <a-slider v-model:value="value2" range :reverse="reverse" />
                </div>
                <div class="filter-range-amount mb-3">
                  <p class="fs-14">Price: <span>$5 - $210</span></p>
                </div>
              </div>
            </div>
            <div class="accordion">
              <div class="accordion-item mb-3">
                <div class="accordion-header" id="accordion-headingTwo">
                  <div
                    class="accordion-button fs-18 p-0 mb-3"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-collapseTwo"
                    aria-expanded="true"
                    aria-controls="accordion-collapseTwo"
                    role="button"
                  >
                    Ratings
                  </div>
                </div>
                <div
                  id="accordion-collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="accordion-headingTwo"
                >
                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <label class="form-check-label d-block">
                        <input class="form-check-input" type="checkbox" checked />
                        <span class="rating">
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i
                          ><span class="float-end">(55)</span>
                        </span>
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label d-block">
                        <input class="form-check-input" type="checkbox" />
                        <span class="rating">
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i
                          ><span class="float-end">(48)</span>
                        </span>
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label d-block">
                        <input class="form-check-input" type="checkbox" />
                        <span class="rating">
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i
                          ><span class="float-end">(13)</span>
                        </span>
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label d-block">
                        <input class="form-check-input" type="checkbox" />
                        <span class="rating">
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i
                          ><span class="float-end">(05)</span>
                        </span>
                      </label>
                    </div>
                    <div class="form-check mb-2">
                      <label class="form-check-label d-block">
                        <input class="form-check-input" type="checkbox" />
                        <span class="rating">
                          <i class="fas fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i>
                          <i class="fa-regular fa-star filled ms-1"></i
                          ><span class="float-end">(00)</span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-dark w-100">Search</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
